import React from 'react';
import { THEME } from '../../constants/appConfig';

const LoadingSpinner = ({ 
    size = 'medium', 
    message = 'Loading...', 
    fullScreen = false,
    color = THEME.colors.primary 
}) => {
    const sizes = {
        small: '20px',
        medium: '40px',
        large: '60px'
    };

    const spinnerStyle = {
        width: sizes[size],
        height: sizes[size],
        border: `3px solid rgba(0, 0, 0, 0.1)`,
        borderTop: `3px solid ${color}`,
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        margin: '0 auto'
    };

    const containerStyle = fullScreen ? {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999
    } : {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
    };

    return (
        <>
            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
            <div style={containerStyle}>
                <div style={spinnerStyle}></div>
                {message && (
                    <p style={{ 
                        marginTop: '16px', 
                        color: '#666', 
                        fontSize: '14px',
                        textAlign: 'center' 
                    }}>
                        {message}
                    </p>
                )}
            </div>
        </>
    );
};

export default LoadingSpinner;